import React from 'react';

const MailIcon: React.FC<
  React.PropsWithChildren<React.SVGProps<SVGSVGElement>>
> = (props) => {
  return (
    <svg
      role="presentation"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 78 59"
      xmlSpace="preserve"
      {...props}
    >
      <path
        fill="#fff"
        d="M73.246 1.059l-67.61-1L0 6.16l1.316 46.95 3.149 5.831h67.5l6.058-2.66V7.488zm-6.055 14.12l-27.14 21.743L10.273 13.59l1.32-3.445 5.005-1.332 23.191 17.222L63.527 8.812l3.43 1.47zm0 0"
      ></path>
    </svg>
  );
};

export default MailIcon;
